
import request from '@/api/config';
import { TLang } from '@/utils/lang';
import { getLocalStorage, setCookie, setLocalStorage, setSessonStorage } from './util';
export const commonApi = {
  prefixStr: ''
};
